import { useState } from "react";

// Small persisted open/collapsed state for a section header.
export function useCollapse(key, defaultOpen = true) {
    const [open, setOpen] = useState(() => {
        try { const v = localStorage.getItem(key); if (v !== null) return v === "1"; } catch { /* ignore */ }
        return defaultOpen;
    });
    const toggle = () => setOpen((o) => {
        const n = !o;
        try { localStorage.setItem(key, n ? "1" : "0"); } catch { /* ignore */ }
        return n;
    });
    return [open, toggle];
}
